import 'babel-polyfill';
import 'dom4';
import 'whatwg-fetch';
import 'mdn-polyfills/NodeList.prototype.forEach';
